module.exports = __webpack_public_path__ + "static/emailmarketing-8a194f96564839aa40f6bcabced46cba.svg";